import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-epa-input',
  templateUrl: './epa-input.component.html',
  styleUrls: ['./epa-input.component.scss']
})
export class EpaInputComponent implements OnInit {
    @Input() public label: string;
    @Input() public value: string;
    @Input() public disabled: boolean = false;
    @Input() public required: boolean = false;
    @Input() public control: FormControl;
    @Input() public type: string = 'text';
    @Input() public showEye: boolean = false;
    @Output() focus = new EventEmitter();
    @Output() focusOut = new EventEmitter();

    public isPasswordShown: boolean;

    constructor() { }

    ngOnInit() {
    }

    public togglePassword = (): void => {
        this.isPasswordShown = !this.isPasswordShown;
        this.type = this.isPasswordShown ? 'text' : 'password';
    }

}
